import React from "react";
import {Link} from "react-router-dom";
import styles from "./start-page.module.css";
import {Page} from "../../components/page/page";
import ImageMale from "../../images/landing-male.png";
import ImageFemale from "../../images/landing-female.png";
import {useDispatch} from "react-redux";
import {updateProfile} from "../../../../api";
import {setGender} from "../../store/stateSlice";

const StartPage = () => {

    const dispatch = useDispatch();

    const handleContinue = (gender) => {
        dispatch(setGender(gender))
        updateProfile({
            land: "future",
            step: "step1",
            topicType: "gender",
            topic: "What is your gender?",
            answer: {
                gender: gender
            }
        })
    }

    return (
        <div className={styles.page_container}>
            <Page title="Discover your true life path with the wisdom of Stars"
                  hideSteps={true} hideContinueButton={true}>
                <p className={styles.subtitle}>Take a quick quiz to receive your personal astrological reading to navigate your love life,
                    career and personal growth.</p>
                <div>
                    <p className={styles.text_gender}>Select your gender:</p>
                    <div className={styles.buttons_container}>
                        <Link to="./how-familiar" onClick={() => handleContinue("Male")}>
                            <div className={styles.button}>
                                <div className={styles.photo_male}><img src={ImageMale} alt="male"/></div>
                                <div className={styles.button_text_male}>
                                    <p>Male</p>
                                    <svg width="8"
                                         height="14" viewBox="0 0 8 14" fill="none">
                                        <path
                                            d="M0.808978 1.53183L1.87847 0.463351L7.7037 6.28657C7.7976 6.37987 7.87212 6.49083 7.92297 6.61305C7.97382 6.73527 8 6.86634 8 6.99872C8 7.13109 7.97382 7.26216 7.92297 7.38438C7.87212 7.5066 7.7976 7.61756 7.7037 7.71087L1.87847 13.5371L0.809986 12.4686L6.27738 7.00023L0.808978 1.53183Z"
                                            fill="white"></path>
                                    </svg>
                                </div>
                            </div>
                        </Link>
                        <Link to="./how-familiar" onClick={() => handleContinue("Female")}>
                            <div className={styles.button}>
                                <div className={styles.photo_female}><img src={ImageFemale} alt="female"/></div>
                                <div className={styles.button_text_female}>
                                    <p>Female</p>
                                    <svg width="8"
                                         height="14" viewBox="0 0 8 14" fill="none">
                                        <path
                                            d="M0.808978 1.53183L1.87847 0.463351L7.7037 6.28657C7.7976 6.37987 7.87212 6.49083 7.92297 6.61305C7.97382 6.73527 8 6.86634 8 6.99872C8 7.13109 7.97382 7.26216 7.92297 7.38438C7.87212 7.5066 7.7976 7.61756 7.7037 7.71087L1.87847 13.5371L0.809986 12.4686L6.27738 7.00023L0.808978 1.53183Z"
                                            fill="black"></path>
                                    </svg>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            </Page>
        </div>
    );
}

export {StartPage};